<template>
  <el-container :class="['bizPage-page', busiCode, busiCode + '-' + userType]">
      <flowTip ref="flowTip"></flowTip>
      <el-main class="bizPage-main customer-view" ref="bizPageMain" id="bizPageMain">
          <!-- <el-form :inline="true" label-position="right"> -->
              <component 
              class="bizpage-child-box"
                  :is= "pageName" 
                  :key = "pageRandom" 
                  :bizData.sync="bizData" 
                  :historyData="historyData" 
                  :oppBusiData.sync="oppBusiData" 
                  :groupDatas.sync="groupDatas" 
                  :isDisablePage="isDisablePage"
                  :busiLogic='busiLogic'
                  :isShowPrev="isShowPrev"
                  :isShowNext="isShowNext"
                  @showOcrCard="showOcrCard" 
                  :ref="pageName" 
                  @updateLeftStatusByRouter="updateLeftStatusByRouter"
                  @showRestore="showRestore"
                  @on-next-click="next" 
                  @change-show-prev="changeShowPrev"
                  @remove-flow-tip="removeFlowTip"
                  @push-flow-tip="pushFlowTip"
                  @hide-footer="hideFooter"
              >
              </component>
          <!-- </el-form> -->
      </el-main>
      <try-again :message-type="messageType" v-on:reloadPage="refreshPage" v-if="messageTypeShow"></try-again>
      <!-- <el-footer class="bizPage-footer">
          <kui-button ref = 'footerBtn' :options = "{buttonGroup:[{text:'还原',value:'rest',handler:restore,width: 180,show:false},{text:'上一步',value:'prev',handler:prev,width: 180},{text:'下一步',value:'next',type:'primary',handler:next,width: 180}]}" />
          
      </el-footer> -->
    <el-footer v-show="isShowFooter" class="bizPage-footer fixed_btn operator-footer-btn-group">
        <el-col :span="4" v-if="isShowRestore">
          <el-button class="button restore" round @click="restore">还原</el-button>
        </el-col>
        <el-col :span="4" v-if="isShowPrev">
          <el-button id="bizPagePrevBtn" class="button light-button" :disabled="disablePrev" round @click="prev">
            {{ prevBtnText }}</el-button>
        </el-col>
        <el-col :span="4" v-if="isShowNext">
          <el-button id="bizPageNextBtn" class="button  light-button-save" :disabled="disableNext" round @click="next">
            {{ nextBtnText }}</el-button>
        </el-col>
        <el-col :span="4" v-if="apptStatus==1 || !apptStatus">
          <el-button id="bizEntryNextBtn" class="button light-button-save" :disabled="disableNext" round @click="next(false)">暂存</el-button>
        </el-col>
    </el-footer>
      <!-- <ocr-card v-if="isShowOcrCard" 
          @getOcrInfo="getOcrInfo"
           @ocrBackAction ="ocrBackAction" :ocrBackType="'1'"  :ocrCardType = "ocrCardType" :orgCls = "orgCls">
      </ocr-card>
      <ocr-only ref="ocrOnly"></ocr-only>
      <kui-dialog ref = "showHelpPageDialog" :options = "{title:'帮助指引',center:true,width: '80%',height:900,top:'0',destroyOnClose:true,buttons:[{text:'关闭'}]}">
          <vueshowpdf v-if = "!!pageHelpUrl" :pdfurl="pageHelpUrl" ></vueshowpdf>
      </kui-dialog> -->
  </el-container>
</template>

<script>
// import tryAgain from "../../components/common/tryAgain.vue";
import flowTip from "../../components/common/flowTip";
// import vueshowpdf from "../../components/common/vue-pdf";


export default {
  name:"bizPage",
  components: {
    // tryAgain,
    flowTip,
    // ocrCard,
    // vueshowpdf,
    // ocrOnly
  },
  data () {
    return {
      pageRandom:0,
      isFirstLoad:false,
      messageType: "loadFail",  //页面异常的提示信息
      messageTypeShow: false,   //页面加载异常显示页面的标志位
      isShowRestore: false,
      disablePrev: false,
      disableNext: false,
      ocrCardType: "",
      orgCls:"",
      isShowOcrCard:false,
      isShowFooter:true,
      pageHelpUrl:"",
      isDisablePage: false
    };
  },
  provide () {
    return {
      hideFooter: this.hideFooter,
    };
  },
  props: ["bizData", "historyData", "oppBusiData", "pageName","isShowPrev", "isShowNext", "save", "groupDatas", "busiCode", "clickLeftStep","bizConfig","disabledArray","noUpdateApptStatus"],
  created () {
    if(this.bizConfig.logicBusiCode){
      this.$options.components[this.pageName] = require(`../../business/businessFile//${this.bizConfig.logicBusiCode}/${this.pageName}.vue`).default;
      return;
    }

    this.$options.components[this.pageName] = require(`../../business/businessFile//${this.busiCode}/${this.pageName}.vue`).default;
    this.isFirstLoad = true;
  },
  activated () {
    if(!this.isFirstLoad) {
      this.pageRandom = Math.random();
    }
      
    this.$nextTick(() => {
      this.initPage();
      this.isFirstLoad = false;
    });
      
  },
  deactivated () {
    console.log("deactivated");
  },
  computed: {
    // busiCode() {
    //     return this.$store.state.busiCode;
    // },
    userType () {
      return this.$store.state.usertype;
    },
    busiLogic () { // busiLogic业务逻辑数据体
      return this.$options.components[this.pageName].methods;
    },
    isCommit: function () { // 控制是否提交数据
      return this.$router.getCurrentRoute().isCommit;
    },
    qsVersionName () {
      return this.$bizcfg.getBizConfigName(this.$definecfg.QSJGDM_CONST[this.$basecfg.qsVersion]);
    },
    modifyType: function () {
      return "modifyType" in this.$route.query ? this.$route.query.modifyType : -1;
    },
    prevBtnText () {
      return this.$router.getCurrentRoute().prevBtnText;
    },
    nextBtnText () {
      return this.$router.getCurrentRoute().nextBtnText;
    },
    isDisabled () {
      return !!this.disabledArray.length;
    },
    compBusiModule () {
      var curouter = this.$router.getCurrentRoute();
      return curouter.compBusiModule || "";
    },
    nodeType (){
      return this.$route.path.split("/")[4];
    },
    apptStatus: function (){
      return this.$store.state.apptStatus;
    },
  },
  methods: {
    initPage () {
      //页面切换初始化，清除所有提示项，应该所有业务都是这个逻辑
      // this.$refs.flowTip&&this.$refs.flowTip.removeAllFlowTip();
      //切换页面默认显示底部按钮
      this.isShowFooter = true;
      this.$nextTick(()=>{
        this.disabledArray.forEach(v=>{
          this.pushFlowTip(v);
        });
      });
      if(!this.$options.components[this.pageName] || !this.$options.components[this.pageName]._compiled) {
        this.$options.components[this.pageName] = require(`../../business/businessFile//${this.busiCode}/${this.pageName}.vue`).default;
      }
      // this.bizData = _.cloneDeep(this.historyData)
      //修复报错，VUE是单向流，子组件原则上不能直接更改父组件，但是本项目框架一直以来都是直接改动的，
      //但是为了消除警告，不能改变bizdata的内存地址所以不能重新赋值，改为用assign，数据上应该没什么问题by 林思聪
      this.bizData = Object.assign(this.bizData || {}, this.historyData);
      this.initBizRules();
      this.$emit("updateBizAccess", this.compBusiModule);
      this.$nextTick(() => {
        var bizPageMainDom = this.$el.querySelector("#bizPageMain");
        bizPageMainDom && (bizPageMainDom.scrollTop = 0);
        //this.$options.components[this.pageName] && this.$options.components[this.pageName].mounted()
      });
    },
    //把流程提示组件的方法直接挂载到bizEntry实例上
    getTypeLength (type) {
      return this.$refs.flowTip.getTypeLength(type);
    },
    pushFlowTip (tip) {
      this.$refs.flowTip.pushFlowTip(tip);
    },
    removeFlowTip (key) {
      this.$refs.flowTip.removeFlowTip(key);
    },
    restore () {
      setTimeout(() => {
        this.initPage();
      }, 500); // 设500ms以显示加载框
    },
    initBizRules () { // 页面更新完后，初始化执行页面规则以及字段规则
      // 1.执行页面处理函数
      if ("pageActivated" in this.busiLogic) {
        this.busiLogic.pageActivated(this, this.groupId);
      }
    },
    changeShowPrev (flag=false) {
      // this.isShowPrev = false;
      this.$router.updateRoute(this.$router.getCurrentRouteIndex(), "isShowPrev", flag);
    },
    showRestore (val){
      this.isShowRestore = val;
    },
    onRestoreClick (){
      let that = this;
      that.busiLogic.restockClick && _.isFunction(that.busiLogic.restockClick) && that.busiLogic.restockClick(that) ;
    },
    prev () {
      let that = this;
      return Promise.all([
        that.busiLogic.preValidate && _.isFunction(that.busiLogic.preValidate) ? that.busiLogic.preValidate(that) : true
      ]).then(function (res) {
        if (res[0] === false) {
          return;
        } else {
          that.$emit("on-prev-click");
        }
      });
    },
    //新增暂存功能，needValid为false,不校验字段，只保存数据，不跳转，且不能更新node_code
    next: _.debounce (function (needValid=true){ 
      let that = this;
      // 只允许跳转路由,不允许校验保存数据的预受理状态
      if (that.noUpdateApptStatus.includes(that.apptStatus)) {
        that.$emit("on-next-click");
        return;
      }


      return Promise.all([
        that.busiLogic.validate && _.isFunction(that.busiLogic.validate) ? that.busiLogic.validate(that) : true
      ]).then(function (res) {

        if (needValid && res[0] === false) {
          return;
        }
        let params =  that.bizData;
        let baseData = {};
        if(!needValid){
          //暂存 复用原来的node_code
          baseData.NODE_CODE = -1;
        }

        if (!that.isCommit) { // 不提交需缓存当前业务数据
          that.historyData = Object.assign(that.historyData, that.bizData);
          // that.$storage.setSession(that.$definecfg.BUSI_INFO, that.historyData);
          //更新historydata的值
          that.$emit("on-next-click");
        } else {
          return that.save(that, params, baseData).then(function (response) {
            needValid&&that.$emit("on-next-click");
            if(!needValid){
              vm.alert("暂存成功");
            }
          }).catch(function (err) {
            if (err !== "preventNextStep") {   //阻止跳转下一页
              alert(err.toString() + "，保存失败");
            }
          });
        }
      });
    }, 1000, {
      "leading": true,
      "trailing": false
    }),
    refreshPage: function () { // 重新加载页面
      this.initPage();
      this.messageTypeShow = false;
    },
    hideFooter (bool) {
      this.isShowFooter = bool;
    },
    showOcrCard (val){
      this.isShowOcrCard = val.isShowCard;
      this.ocrCardType = val.ocrCardType; 
      this.orgCls = val.orgCls; 
    }, 
    //返回银行卡OCR数据
    getOcrInfo:function (cardInfo){
      this.isShowOcrCard = false;
      if(cardInfo && !_.isEmpty(cardInfo)){
        if("readCardInfoAction" in this.busiLogic) {
          this.busiLogic["readCardInfoAction"](this,cardInfo);
        }
      }
    },
    ocrBackAction:function (val){
      this.isShowOcrCard = val;
    },
    updateLeftStatusByRouter (flag, routerIndexArr) {
      this.$emit("updateLeftStatusByRouter",flag, routerIndexArr);
    },
    showLoading (text) {
      if (!!text) {
        this.myLoading({
          
          loadingText: text || "正在核对您的业务状态&请稍候...",
          autoHide: false
        });
      } else {
        this.myLoading({
          showLoading: false
        });
      }
    },
  },
  watch: {
    pageName (val) {
      this.initPage();
    },
    clickLeftStep (val) {
      let that = this;
      if (!val) return;

      that.$emit("change-toplink-name", "");
      
          
         
      return Promise.all([
        that.busiLogic.validate && _.isFunction(that.busiLogic.validate) ? that.busiLogic.validate(that) : true
      ]).then(function (res) {
        if (res[0] === false) {
          return;
        }
        if (!that.isCommit) { // 不提交需缓存当前业务数据
          that.historyData = Object.assign(that.historyData, that.bizData);
          // that.$storage.setSession(that.$definecfg.BUSI_INFO, that.historyData);
          //更新historydata的值
          that.$emit("clickLeftStepBack", val);
        } else {
          that.showloading("正在核对您提交的业务数据...");
          return that.save(that, that.bizData).then(function (response) {
            that.$emit("clickLeftStepBack", val);
          }).catch(function (err) {
            if (err !== "preventNextStep") {   //阻止跳转下一页
              alert(err.toString() + "，保存失败");
            }
          }).finally(function () {
            that.showloading();
          });
        }
      });
    },
    prevBtnText: function (val) {
      this.$nextTick( () => {
        this.$refs["PREV_BUTTON"].button({text: val});
      });
          
    },
    "disabledArray": {
      handler (newVal, oldVal) {
        this.$nextTick(()=>{
          this.removeFlowTip("notUpdateAppt");
          this.removeFlowTip("noEditAuth");
          this.removeFlowTip("foribinMobileLogin");
          newVal.forEach(v=>{
            this.pushFlowTip(v);
          });
          if(newVal.length){
            this.isDisablePage = true;
          }else{
            this.isDisablePage = false;
          }
        });
      },
      immediate: true
    },
  }
};
</script>

<style lang="less">
@import url('../../styles/less/theme.less');
@import "~@/styles/less/variable.less";

.bizPage-page {
  .bizPage-main {
      // margin-top: 20px;
      // background-color: #ffffff;
      display: flex;
      flex-basis: 0%; 
      overflow: auto;
      padding: 0;
      .bizpage-child-box{
        width: 100%;
        height: 100%;
      }
      &.disabled {
          position: relative;
          &::after{
              display: block;
              content: "";
              position: absolute;
              width: 100%;
              height: 100%;
              top: 0;
              left: 0;
              z-index: 2;
              background-color:rgba(255, 255, 200, 0.5);
          }
      }
      .el-form-item__label{
        // font-size: @LabelFontSize;
        // color: @LabelColor;
        // width: 188px;
        text-align: right;
        padding: 8px;
        color:#343434;
        .fontsize-text-medium();
      }
      
      .el-form-item__content{
        font-size: 14px; 
        .el-input.is-disabled{
          .el-input__inner{ 
            font-size: 14px;
            color:#858C9E;
            padding:0 15px;
            background-color: #f5f7fa;
            opacity:1;
          }
        }
        .el-input{
          .el-input__inner{
            font-size: @ValueFontSize;
            color: @ValueColor;
            background:#fff; 
            // border-radius: 0;border:none; border-bottom: 1px solid #000;
            opacity:1;
          }
        }
      }
  }
}

// @media screen and (min-aspect-ratio: 4/3) {
//     .bizPage-page {
//         cursor: pointer;
//     }
// }
</style>



// WEBPACK FOOTER //
// src/pages/bizPage/bizPage.vue